import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IMapEvent } from '@types-custom/models/ui/map-viewer-model';
import { BehaviorSubject, Observable, of, map, switchMap, catchError, throwError } from 'rxjs';
import { AddressComponent, Bound, IAddressModel } from '@types-custom/models/business/google-api.model';

@Injectable()
export class GeoLocationService {
  private apiKey = this.environment.geoLocations?.apiKey;
  private bounds = this.environment.geoLocations?.bounds;

  pointerData$ = new BehaviorSubject<IMapEvent | undefined>(undefined);
  clickInteractionDispatcher: BehaviorSubject<any>;
  clickEventsDispatcher: BehaviorSubject<any>;

  getBounds(): Bound {
    return this.bounds;
  }

  constructor(
    @Inject('environment') private environment: any,
    private httpClient: HttpClient
  ) { }


  getLocationFromAddress(address: string): Observable<IAddressModel> {
    const url = `${this.environment.geoLocations.getAddressUrl}/json`;
    const options = {
      key: this.apiKey,
      address,
      components: "locality:Almeria|country:ES"
    };
    return this.httpClient.get(url, { params: options })
      .pipe(
        map((apiResponse: any) => this.googleAPIModelMapper(apiResponse, apiResponse[0]?.geometry.location.lat, apiResponse[0]?.geometry.location.lng)),
        catchError(error => {
          console.error('Failed to get address model:', error);
          return throwError(() => error);
        })
      )
  }

  getAddress2(pointerData: IMapEvent): Observable<IAddressModel> {
    if (!pointerData) {
      return of(`Sin dirección` as unknown as IAddressModel);
    }

    const { lat, lng } = pointerData;
    const options = {
      key: this.apiKey,
      latlng: `${lat},${lng}`,
    };

    const url = `${this.environment.geoLocations.getAddressUrl}/json`;
    return this.httpClient.get(url, { params: options }).pipe(
      map(apiResponse => this.googleAPIModelMapper(apiResponse, lat, lng)),
      catchError(error => {
        console.error('Failed to get address model:', error);
        return throwError(() => error);
      })
    );
  }

  private googleAPIModelMapper(
    apiResponse: any, // Consider using a type/interface for the Google API response
    lat: number,
    lng: number
  ): IAddressModel {
    const { results = [] } = apiResponse;
    const addressComponents = [
      'administrative_area_level_1',
      'administrative_area_level_2',
      'country',
      'neighborhood',
      'route',
      'street_number',
      'sublocality_level_1',
      'postal_code',
    ];

    if (results.length) {
      const { address_components = [] } = results[0];
      const model: { [key: string]: any } = {};

      addressComponents.forEach(addressComponent => {
        const foundComponent = address_components.find((component: AddressComponent) => component.types.includes(addressComponent));
        model[addressComponent] = foundComponent?.long_name;
      });
      // const localityInfo = this.getLocalityByName(model.sublocality_level_1);
      lat = lat ?? results[0].geometry.location.lat;
      lng = lng ?? results[0].geometry.location.lng;

      const result: IAddressModel = {
        ...model,
        response: apiResponse,
        lat,
        lng,
        // localityId: localityInfo?.localityId || '',
      };

      const bestAddressFull = results[0];
      result.addressStr = bestAddressFull.formatted_address.split(',')[0];

      return result;
    }

    return { response: apiResponse, lat, lng };
  }
}
